export default "__VITE_ASSET__BJAgHxmd__"